import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Transaction } from 'types';

import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';
import SharesTransferOperationTableRow from './SharesTransferOperationTableRow';

const SharesTransferOperationTableBody: FC = () => {
  const { t } = useTranslate();

  const { data } = useOperationDetailsPage();

  const transactions = (data.operation?.transactions as Transaction[]) || [];

  const hasData = transactions.length > 0;

  const chunkedTransactions = [];
  for (let i = 0; i < transactions.length; i += 2) {
    chunkedTransactions.push(transactions.slice(i, i + 2));
  }

  return (
    <>
      {hasData ? (
        <tbody>
          {chunkedTransactions?.map(
            (transactionsPair: Transaction[], index: number) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr className="nk-tb-item" key={`shares-transfer-row-${index}`}>
                <SharesTransferOperationTableRow
                  index={index}
                  transactionsPair={transactionsPair}
                />
              </tr>
            )
          )}
        </tbody>
      ) : (
        <EmptyStateForTable
          mainMessage={t('NoDataFound')}
          infoMessage=""
          colspan={7}
        />
      )}
    </>
  );
};

export default SharesTransferOperationTableBody;
